import { frFR } from '@mui/material/locale';
import { createTheme } from '@mui/material/styles';
import { lighten } from '@mui/material/styles';
import { blueGrey, deepOrange, deepPurple, grey, red, green } from '@mui/material/colors';

let theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1366, // default = 1200
            xl: 1920  // default = 1536
        }
    },
    palette: {
        primary: {
            main: blueGrey[800],
            contrastText: "#fff"
        },
        secondary: {
            main: deepOrange[500],
            contrastText: "#fff"
        },
        correct: {
            main: green[500],
            dark: green[900],
            light: green[100],
            contrastText: "#fff"
        },
        selected: deepOrange[500], // Utilisé sur drawer ReclamationsPage

        background: {
            default: blueGrey[50],
            paper: grey[50]
        },

        icon: grey[500],

        table: {
            row: {
                error: red[50],
                warning: deepOrange[50]
            },
            cell: {
                error: red[200]
            }
        },

        tabsInfo: blueGrey[400], // Utilisé pour les onglets dans Informations

        client: {
            marche: {
                prive: deepOrange[500],
                public: deepPurple[500]
            }
        }
    },

    components: {
        // Name of the component
        MuiTableCell: {
            styleOverrides: {
                root: {
                    "&:last-child": {
                        paddingRight: 24
                    }
                }
            }
        }
    },


}, frFR);

// Réutilisation de couleur de la palette : 

theme = createTheme(theme, {
    components: {
        MuiTab: {
            styleOverrides: {
                root:
                {
                    color: theme.palette.primary.light,
                    "&.Mui-selected": {
                        color: theme.palette.primary.contrastText,
                    }
                },
            }
        },
        MuiRadio: {
            styleOverrides: {
                colorPrimary:
                {
                    "&.Mui-checked": {
                        color: theme.palette.secondary.main,
                    }
                }
            }
        },
        MuiCheckbox: {
            styleOverrides: {
                colorPrimary:
                {
                    "&.Mui-checked": {
                        color: theme.palette.secondary.main,
                    }
                }
            }
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: theme.palette.secondary.light,
                    },
                    "& .MuiOutlinedInput-root.Mui-focused  .MuiOutlinedInput-notchedOutline":
                    {
                        borderColor: theme.palette.secondary.main,
                    },
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    "&.Mui-selected":
                    {
                        backgroundColor: lighten(theme.palette.secondary.main, 0.85),
                    },
                },
            },
        },
        MuiStepper: {
            styleOverrides: {
                root: {
                    "& .MuiSvgIcon-root.Mui-completed":
                    {
                        color: theme.palette.secondary.main,
                    },
                },
            },
        },

    },

    style: {
        link: {
            textDecoration: 'none',
            color: theme.palette.primary.main,
            '&:hover': {
                color: theme.palette.secondary.main
            },
            '&:focus': {
                outline: `2px solid ${theme.palette.secondary.main}`,
                outlineOffset: '2px'
            }
        },
        aideMessage: {
            backgroundColor: '#FFF3E0',
            color: '#F57C00',
            padding: '8px 12px',
            margin: '4px 0 0 0',
            borderRadius: '4px',
            borderLeft: '4px solid #F57C00',
            fontWeight: 'bold'
        }
    },

});

export default theme;
